import React, { useState, useEffect, useMemo, useCallback } from "react"
import { createPortal } from "react-dom"
import { useGlobalContext } from "../data/GlobalContext"
import { promotionsData } from "../data/PromotionData"
import CountdownTimer from "../data/CountdownTimer"
import Deposit from "../transactions/Deposit"
import LuckyDraw8 from "./games/LuckyDraw8"
import RollingCommission from "../promotions/RollingCommission"
import ModuleFaChaiGrandSpinAle from "../promotions/promotion_modules/modules_fcGrandSpinAle"
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw"
import ModulesPeraBayong from "../promotions/promotion_modules/modules_peraBayong"
import ModuleJustDoYourBest from "../promotions/promotion_modules/modules_justDoYourBest"
import LoginToPlay from "../data/LoginToPlay"
import ModuleFlexiShowDown from "../promotions/promotion_modules/modules_flexiSpinShowdown"
import ModuleCQ9Funalo from "../promotions/promotion_modules/modules_cq9Funalo"
import ModuleLoveMagicSpin from "../promotions/promotion_modules/modules_loveMagicSpin"
import ModuleRaceOfReels from "../promotions/promotion_modules/ModuleRaceOfReels"
import ModuleBNGSplash from "../promotions/promotion_modules/ModuleBNGSplash"
import ModuleJiliGrandSlot from "../promotions/promotion_modules/ModuleJiliGrandSlot"
import ModuleRainOfWins from "../promotions/promotion_modules/ModuleRainOfWins"

export default function FeaturedPromoMobile() {
  const [isFeaturedPromoOpen, setIsFeaturedPromoOpen] = useState(true)
  const [isFeaturedPromoPop, setIsFeaturedPromoPop] = useState(false)
  const { setShowEasterEgg, showMysteryFridayBtn, doubleUpTurnover } =
    useGlobalContext()
  const [isShowViewEntry, setIsShowViewEntry] = useState(false)
  const [showRolling, setShowRolling] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [isShowDoubleUp, setIsShowDoubleUp] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [login, setLogin] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date())
    }, 60 * 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true")
  }, [])

  useEffect(() => {
    document.body.style.overflow = isFeaturedPromoPop ? "hidden" : "auto"
    return () => (document.body.style.overflow = "auto")
  }, [isFeaturedPromoPop])

  const getPaydayWindowPH = useCallback((date = new Date()) => {
    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Manila",
      year: "numeric",
      month: "2-digit",
    })

    const parts = formatter.formatToParts(date)

    const year = parts.find((part) => part.type === "year").value
    const month = parts.find((part) => part.type === "month").value

    return {
      startDate: `${year}-${month}-15T12:00:00+08:00`,
      endDate: `${year}-${month}-18T12:00:00+08:00`,
    }
  }, [])

  const isPaydayPromoActivePH = useCallback(
    (date = new Date()) => {
      const { startDate, endDate } = getPaydayWindowPH(date)

      const nowTime = date.getTime()
      const startTime = new Date(startDate).getTime()
      const endTime = new Date(endDate).getTime()

      return nowTime >= startTime && nowTime < endTime
    },
    [getPaydayWindowPH]
  )

  const handlePromoPop = () => {
    setIsFeaturedPromoOpen(false)
    setIsFeaturedPromoPop(true)
  }

  const handleClosePop = () => {
    setIsFeaturedPromoOpen(true)
    setIsFeaturedPromoPop(false)
  }

  const featuredPromotions = useMemo(() => {
    return promotionsData
      .filter((promotion) => promotion.featuredPromotion)
      .sort((a, b) => a.priority - b.priority)
  }, [])

  const nextPromotion = useMemo(() => {
    const paydayPromotion = promotionsData.find(
      (promotion) => promotion.title === "Payday Bonus"
    )

    if (paydayPromotion && isPaydayPromoActivePH(now)) {
      const { startDate, endDate } = getPaydayWindowPH(now)

      return {
        ...paydayPromotion,
        startDate,
        endDate,
      }
    }

    const featuredPromo = promotionsData.find((p) => p.isShowOnFeatured)

    if (featuredPromo) {
      return featuredPromo
    }

    const dayMap = { thursdayPromotion: 4, fridayPromotion: 5 }
    const currentDay = now.getDay()

    const filtered = promotionsData.filter(
      (p) => p.highlightPromotion && (p.thursdayPromotion || p.fridayPromotion)
    )

    const sorted = filtered
      .map((p) => {
        const day =
          dayMap[p.thursdayPromotion ? "thursdayPromotion" : "fridayPromotion"]

        let diff = day - currentDay
        if (diff <= 0) diff += 7

        return { ...p, diff }
      })
      .sort((a, b) => a.diff - b.diff)

    return sorted[0]
  }, [now, getPaydayWindowPH, isPaydayPromoActivePH])

  const modalComponents = {
    "2/30 Lottery Draw": ModulesLotteryDraw,
    "Pera O Bayong": ModulesPeraBayong,
    "JDB Exclusive Promo": ModuleJustDoYourBest,
    "FC Grand Spin-Ale": ModuleFaChaiGrandSpinAle,
    "Flexi-Spin Showdown": ModuleFlexiShowDown,
    "CQ9 Funalo": ModuleCQ9Funalo,
    "JDB Spin Tournament": ModuleLoveMagicSpin,
    "Race of Reels: Slots Tournament": ModuleRaceOfReels,
    "BNG Splash Spin Into Summer": ModuleBNGSplash,
    "Jili Grand Slot": ModuleJiliGrandSlot,
    "Rain Of Wins": ModuleRainOfWins,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const requireLogin = (callback) => {
    if (isLoggedIn) callback()
    else setLogin(true)
  }

  const hiddenTitlesForPlayNow = [
    "Pera O Bayong",
    "Exclusive Rolling Commission",
    "2/30 Lottery Draw",
    "8's Your Lucky Draw",
    "CQ9 Funalo",
    "Fortune Drops 2026",
    "JDB Spin Tournament",
    "CQ9 King of Betting",
    "Race of Reels: Slots Tournament",
    "BNG Splash Spin Into Summer",
    "BNG Prize Drop",
    "Gates of Olympus Roulette",
    "Jelly Express Daily Tournament",
    "Sweet Bonanza 2500",
    "Road to Glory",
  ]

  const hiddenTitlesForJili = [
    ...hiddenTitlesForPlayNow,
    "Pragmatic Play Daily",
    "Recovery Bonus",
    "Flexi-Spin Showdown",
    "8PM Recovery Hour",
    "CQ9 Funalo",
    "TPGreat Spins of Fortune",
    "JDB Spin Tournament",
    "PGSoft Global Cash",
    "Fast Cashout Guarantee",
    "Jili Grand Slot",
    "Rain Of Wins",
  ]

  const handlePromoAction = (title) => {
    const actions = {
      "Easter Egg Drop": () => setShowEasterEgg(true),

      "Exclusive Rolling Commission": () =>
        requireLogin(() => setShowRolling(!showRolling)),

      "2/30 Lottery Draw": () => requireLogin(() => setActiveModal(title)),

      "Flexi-Spin Showdown": () => requireLogin(() => setActiveModal(title)),

      "CQ9 Funalo": () => requireLogin(() => setActiveModal(title)),

      "FGH RECOVERY BONUS is back!": () =>
        requireLogin(() => setIsDepositOpen(true)),

      "8PM Recovery Hour": () => requireLogin(() => setIsDepositOpen(true)),

      "Pera O Bayong": () => setActiveModal(title),

      "JDB Exclusive Promo": () => setActiveModal(title),

      "Race of Reels: Slots Tournament": () =>
        requireLogin(() => setActiveModal(title)),

      "Fortune Drops 2026": () =>
        (window.location.href = "/promotion/fortune-drops"),

      "JDB Spin Tournament": () => requireLogin(() => setActiveModal(title)),

      "Pragmatic Play Daily": () =>
        (window.location.href = "/slots/?provider=PP"),

      "TPGreat Spins of Fortune": () =>
        (window.location.href = "/promotion/tpg-great-spins-of-fortune"),

      "Pragmatic Play Zombie School": () =>
        (window.location.href = "/slots/?provider=PP"),

      "BNG Splash Spin Into Summer": () =>
        requireLogin(() => setActiveModal(title)),

      "Jili Grand Slot": () => requireLogin(() => setActiveModal(title)),

      "Rain Of Wins": () => requireLogin(() => setActiveModal(title)),

      "PGSoft Global Cash": () =>
        (window.location.href = "/promotion/pg-global-cash"),

      "BNG Prize Drop": () =>
        (window.location.href = "/promotion/bng-prize-drop"),

      "Sweet Bonanza 2500": () =>
        (window.location.href = "/promotion/pragmatic-play-daily"),

      "Jelly Express Daily Tournament": () =>
        (window.location.href = "/promotion/jelly-express"),

      "Gates of Olympus Roulette": () =>
        (window.location.href = "/promotion/gates-of-olympus"),

      "8's Your Lucky Draw": () => requireLogin(() => setIsShowViewEntry(true)),

      "CQ9 King of Betting": () =>
        (window.location.href = "https://betking.jiamengweiquan.com/newyearph"),

      "Road to Glory": () =>
        (window.location.href = "/promotion/road-to-glory"),
      "Fast Cashout Guarantee": () =>
        (window.location.href = "/promotion/fash-cashout-guarantee"),
    }

    return actions[title]
      ? actions[title]()
      : (window.location.href = "/slots/?provider=JILI")
  }

  return (
    <>
      {login && <LoginToPlay onClose={() => setLogin(false)} />}
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
      {showRolling && (
        <RollingCommission onClose={() => setShowRolling(false)} />
      )}
      {isShowViewEntry && (
        <LuckyDraw8 onClose={() => setIsShowViewEntry(false)} />
      )}

      <div className="featured-promotion-container">
        {/* MAIN BANNER BUTTON */}
        {isFeaturedPromoOpen && nextPromotion && (
          <div className="featured-promotion-btn" onClick={handlePromoPop}>
            <div className="featured-promotion-btn-content">
              <img src={nextPromotion.imgIcon} alt={nextPromotion.title} />
              <div>
                <strong className="featured-promotion-popup-text">
                  {nextPromotion.title}
                </strong>
                <p className="featured-promotion-sub-text">
                  {nextPromotion.subHeading}
                </p>
              </div>
            </div>
            <CountdownTimer {...nextPromotion} />
          </div>
        )}

        {/* POPUP CONTENT */}
        {isFeaturedPromoPop && (
          <div className="featured-promo-pop-container">
            {featuredPromotions.map((promotion) => {
              if (promotion.title === "Pera O Bayong" && !showMysteryFridayBtn)
                return null

              const hidePlayNow = hiddenTitlesForPlayNow.includes(
                promotion.title
              )
              const hideJili = hiddenTitlesForJili.includes(promotion.title)

              return (
                <div key={promotion.id} className="featured-promo-pop-items">
                  <img
                    src={promotion.highlightImgSrc}
                    alt={promotion.title}
                    className="featured-promo-pop-img"
                  />

                  <div className="featured-promo-pop-details">
                    <div>
                      <strong>{promotion.title}</strong>
                      <p>
                        {promotion.userQualification}
                        <span className="promotion-user-rewards">
                          {promotion.userRewards}
                        </span>
                      </p>
                    </div>

                    {/* Play Now (Double Up Eligible) */}
                    {doubleUpTurnover >= 100000
                      ? !hidePlayNow && (
                          <button
                            className="featured-promo-pop-btn"
                            onClick={() => {
                              setIsShowDoubleUp(false)
                              setTimeout(() => setIsShowDoubleUp(true), 0)
                            }}
                          >
                            Play Now
                          </button>
                        )
                      : !hideJili && (
                          <a
                            className="featured-promo-pop-btn"
                            href="/slots/?provider=JILI"
                          >
                            Play Now
                          </a>
                        )}

                    {/* Custom Action Button */}
                    {promotion.title !== "Double Up" &&
                      promotion.title !== "FGH Sign-Up Treat" && (
                        <button
                          className="featured-promo-pop-btn"
                          onClick={() => handlePromoAction(promotion.title)}
                        >
                          {promotion.btnTxt}
                        </button>
                      )}
                  </div>
                </div>
              )
            })}

            <p onClick={handleClosePop} className="featured-promo-close-btn">
              close
            </p>
          </div>
        )}

        {/* DEPOSIT MODAL */}
        {isDepositOpen &&
          createPortal(
            <div className="modal-portal">
              <Deposit
                onClose={() => setIsDepositOpen(false)}
                defaultBonusName="New Member Package Bonus"
              />
            </div>,
            document.body
          )}
      </div>
    </>
  )
}
